import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  CollectModalTitle,
  CollectModalQuestion, 
} from './CollectModal.style';
import { StarFilled} from '@assets';

const CollectModal = ({
  open,
  loading,
  handleClose,
  onOk,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      destroyOnClose
      open={open}
      closable={false}
      width={310}
      confirmLoading={loading}
      cancelText={t("common.cancel")}
      onCancel={handleClose}
      okText={t('common.confirm')}
      onOk={onOk}
    >
      <StarFilled id='modal-icon' />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        <CollectModalTitle> {t("share.collectModalTitle")} </CollectModalTitle>
        <CollectModalQuestion> {t("share.collectModalQuestion")} </CollectModalQuestion>
      </div>
    </Modal>
  )
}

export default CollectModal